import { Proceed } from "@/models/proceed";
import { Pagination } from "@/models/pagination";
import { IProceed, ProceedState } from "@/types/proceed";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<ProceedState, IProceed> = {
  single: (state, single) => {
    state.single = new Proceed(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Proceed(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Proceed();
    state.pagination = new Pagination();
  },
};

export default mutations;
